import { render, staticRenderFns } from "./BulletinView.vue?vue&type=template&id=78bd7e95&"
import script from "./BulletinView.vue?vue&type=script&lang=js&"
export * from "./BulletinView.vue?vue&type=script&lang=js&"
import style0 from "./BulletinView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports